import { overlayEventEmitter } from "@made-people/blueprint-overlay";
import { Flag } from "@made-people/blueprint-flags";
import {
  CountryCode,
  useCountriesAndLanguages,
} from "@made-people/grease-countries-and-languages";
import { useFrontendContext } from "../../hooks/use-frontend-context";

export const SiteSettingsTriggerWithFlag = ({
  className,
}: {
  className?: string;
}) => {
  const { currentCountryCode } = useCountriesAndLanguages();
  const frontendContext = useFrontendContext();

  return (
    <button
      className={className}
      onClick={() => {
        overlayEventEmitter.emit("open", {
          overlayId: "site-settings",
        });
      }}
      type="button"
      aria-label="Open site settings"
    >
      <span className="w-4 [&>svg]:w-full">
        <Flag code={currentCountryCode as CountryCode} />
      </span>
      <span>{currentCountryCode.toUpperCase()}</span>
      <span aria-hidden="true">|</span>
      <span>{frontendContext.currencyCode}</span>
    </button>
  );
};
